import React, { PropTypes } from 'react';

require.ensure([], () => {
    require('./Material-Design-Iconic.less');
    require('./Notifications.less');
});

class Notification extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            bold: this.props.bold
        };
    }

    // LIFECYCLE METHODS

    // OTHER METHODS

    deleteNotification = () => {
        this.props.deleteNotification(this.props.id, this.props.notification.read);
    }

    followNotificationLink (link) {
        window.location = link;
    }

    markAsRead = () => {
        this.props.markAsRead(this.props.id);
    }

    markAsUnread = () => {
        this.props.markAsUnread(this.props.id);
    }

    // RENDER METHOD

    render = () => {
        if (!this.props.notification)
            return null;

        // we don't display deleted messages
        if (this.props.notification.deleted)
            return null;

        let className = "";

        if (this.props.notification.read)
            className += "read ";

        let timestampTokens = this.props.notification.timestamp.split("T");
        let timestamp = timestampTokens[0] + " " + timestampTokens[1].substring(0, 8);

        let text = this.props.notification.body;
        let closingTagStartIndex = text.indexOf("</a>");
        let link = null;

        if (closingTagStartIndex !== -1) {
            let openingTagStartIndex = text.indexOf("<a");
            let openingTagEndIndex = text.indexOf(">", openingTagStartIndex);
            let closingTagEndIndex = closingTagStartIndex + 4;
            // this is the action link
            let path = text.split("/")[3].split("\"")[0];

            link = location.origin + '/' + path;
            // this is the pure text
            text = text.substring(0, openingTagStartIndex) + text.substring(openingTagEndIndex + 1, closingTagStartIndex) + text.substring(closingTagEndIndex);
        }

        return (
            <li  className={className} key={this.props.notification.id + this.props.notification.read} id={this.props.notification.id + this.props.notification.read}>
                <h5>{timestamp}</h5>
                { link !== null
                      ? <h5 style={ { cursor: "pointer" } }
                            onClick={ this.followNotificationLink.bind( this, link ) }>{ text }</h5>
                      : <h5>{ text }</h5>
                }
                <div className="notification-actions">
                    { this.props.notification.read
                          ? <a title="Mark as unread"
                               className="icon-btn"><span onClick={ this.markAsUnread }><span className="md-undo" /></span></a>
                          : <a title="Mark as read"
                               className="icon-btn"><span onClick={ this.markAsRead }><span className="md-done" /></span></a>
                    }
                    <a title="Delete"
                       className="icon-btn">
                           <span onClick={ this.deleteNotification }>
                               <span className="md-delete"/>
                           </span>
                    </a>
                </div>
            </li>
        );
    }
}

Notification.propTypes = {
    bold: PropTypes.bool,
    deleteNotification: PropTypes.func,
    id: PropTypes.number,
    markAsRead: PropTypes.func,
    markAsUnread: PropTypes.func,
    notification: PropTypes.object
};

Notification.defaultProps = {
    bold: false
};

export default Notification;



/** WEBPACK FOOTER **
 ** ./src/app/components/Notification.js
 **/